import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useRef, useState } from "react";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonForAll from "../../components/common/ButtonForAll";
import {
  emailWOValueValidator,
  MobileNoWOValueValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import {
  ActiveInactiveHotelContact,
  createHotelContact,
  deleteHotelContact,
  getAllHotelContacts,
  updateHotelContact,
} from "./services/hotel.services";
import ShadowCard from "../../components/common/ShadowCard";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { clearHotelContactID, setHotelContactID } from "./hotelSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Switch } from "@progress/kendo-react-inputs";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const CreateHotelContact = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const HotelID = location.state?.HotelID;
  const HotelContactDetail = useAppSelector(
    (state) => state.hotel.HotelContactDetail,
  );

  const formRenderPropsRef = useRef<FormRenderProps | null>(null);

  const [hotelPage, setHotelPage] = useState<PageState>(initialDataState);
  const [hotelPageSizeValue, setHotelPageSizeValue] = useState<
    number | string | undefined
  >();

  const pageChangeForHotel = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? HotelContactDetail?.length || event.page.take
        : event.page.take;

    if (targetEvent.value) {
      setHotelPageSizeValue(targetEvent.value);
    }
    setHotelPage({
      ...event.page,
      take,
    });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 12 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyEditHotelCommandCell = (
    props: GridCellProps,
    formRenderProps: FormRenderProps,
  ) => {
    const handleEdit = (item: any) => {
      formRenderProps.onChange("hotel_contact_id", {
        value: item?.hotel_contact_id,
      });
      formRenderProps.onChange("ContactPersonName", {
        value: item?.ContactPersonName,
      });
      formRenderProps.onChange("ContactPersonMobileNo", {
        value: item?.ContactPersonMobileNo,
      });
      formRenderProps.onChange("ContactPersonEmailID", {
        value: item?.ContactPersonEmailID,
      });
      formRenderProps.onChange("ContactPersonDesignation", {
        value: item?.ContactPersonDesignation,
      });
      formRenderProps.onChange("IsActive", {
        value: item?.IsActive,
      });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteHotelContact"));
      dispatch(setHotelContactID(ID));
    };

    return (
      <td
        className={props.className}
        style={{
          ...props.style,
          textAlign: "center",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          onClick={() => handleEdit(props.dataItem)}
          icon={FiEdit}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />

        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          onClick={() =>
            handleOpenDeleteDialog(props.dataItem.hotel_contact_id)
          }
          className="color-red"
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive === 1 ? true : false,
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.hotel_contact_id,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveHotelContact(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllHotelContacts({ HotelID: HotelID }));
        } else {
          dispatch(getAllHotelContacts({ HotelID: HotelID }));
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <div title={`Set ${IsActive ? "Inactive" : "Active"}.`}>
            <Switch
              name="IsActive"
              checked={IsActive}
              onChange={handleActiveInActive}
              size="small"
            />
          </div>
        </Tooltip>
      </td>
    );
  };

  const handleClearContactDetails = (formRenderProps: FormRenderProps) => {
    formRenderProps.onFormReset();
  };

  const handleSubmit = async (values: any) => {
    try {
      if (!values?.hotel_contact_id) {
        const insertPayload = {
          HotelID: HotelID ? HotelID : null,
          ContactPersonName: values?.ContactPersonName
            ? values?.ContactPersonName
            : "",
          ContactPersonMobileNo: values?.ContactPersonMobileNo
            ? `${values?.ContactPersonMobileNo}`
            : "",
          ContactPersonEmailID: values?.ContactPersonEmailID
            ? values?.ContactPersonEmailID
            : "",
          ContactPersonDesignation: values?.ContactPersonDesignation
            ? values?.ContactPersonDesignation
            : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(createHotelContact(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getAllHotelContacts({ HotelID: HotelID }));
          if (formRenderPropsRef.current) {
            handleClearContactDetails(formRenderPropsRef.current);
          }
        }
      } else {
        const updatePayload = {
          ID: values?.hotel_contact_id ? values?.hotel_contact_id : null,
          HotelID: HotelID ? HotelID : null,
          ContactPersonName: values?.ContactPersonName
            ? values?.ContactPersonName
            : "",
          ContactPersonMobileNo: values?.ContactPersonMobileNo
            ? `${values?.ContactPersonMobileNo}`
            : "",
          ContactPersonEmailID: values?.ContactPersonEmailID
            ? values?.ContactPersonEmailID
            : "",
          ContactPersonDesignation: values?.ContactPersonDesignation
            ? values?.ContactPersonDesignation
            : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(updateHotelContact(updatePayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getAllHotelContacts({ HotelID: HotelID }));
          if (formRenderPropsRef.current) {
            handleClearContactDetails(formRenderPropsRef.current);
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      <DeleteHotelDialog />
      <Form
        onSubmit={handleSubmit}
        render={(formRenderProps: FormRenderProps) => {
          formRenderPropsRef.current = formRenderProps;
          return (
            <FormElement>
              <ShadowCard
                style={{
                  padding: 10,
                  marginBottom: 10,
                  marginTop: 10,
                }}
              >
                <GridLayout
                  cols={[{ width: "100%" }]}
                  style={{ marginBottom: 20 }}
                >
                  <GridLayoutItem>
                    <Typography.h4 className="text-dark">
                      {"Hotel Contacts"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <GridLayout
                      style={{ marginRight: 20 }}
                      gap={{ rows: 0, cols: 10 }}
                      cols={[
                        { width: "33.33%" },
                        { width: "33.33%" },
                        { width: "33.33%" },
                      ]}
                    >
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100"
                          name={`ContactPersonName`}
                          label={`Contact Person`}
                          placeholder="i.e. John Smith"
                          astrike={true}
                          validator={requiredValidator}
                          component={FormTextField}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100 right-alighned-field"
                          name={`ContactPersonMobileNo`}
                          label={`Mobile No.`}
                          placeholder="i.e. 9999999999"
                          type="number"
                          component={FormTextField}
                          validator={MobileNoWOValueValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100"
                          name={`ContactPersonEmailID`}
                          label={`Email ID`}
                          placeholder="i.e. example@gmail.com"
                          component={FormTextField}
                          validator={emailWOValueValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100"
                          name={`ContactPersonDesignation`}
                          label={`Designation`}
                          placeholder="i.e. User"
                          component={FormTextField}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="IsActive"
                          label="Status"
                          placeholder="i.e. Active"
                          astrike={true}
                          validator={requiredValidator}
                          component={FormSelectionField}
                          options={STATUSARRAY?.map((status: any) => {
                            return {
                              value: status?.value,
                              label: status?.label,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem
                        style={{ textAlign: "end", marginTop: 36 }}
                      >
                        <ButtonForAll
                          label={
                            formRenderProps?.valueGetter("hotel_contact_id")
                              ? "Update"
                              : "Add"
                          }
                          disabled={
                            formRenderProps?.valueGetter("ContactPersonName")
                              ? false
                              : true
                          }
                          type="submit"
                        />
                        <Button
                          style={{ marginLeft: 10 }}
                          fillMode={"outline"}
                          themeColor={"primary"}
                          type="button"
                          onClick={() => {
                            handleClearContactDetails(formRenderProps);
                          }}
                        >
                          Clear
                        </Button>
                      </GridLayoutItem>
                    </GridLayout>
                  </GridLayoutItem>
                </GridLayout>
                {HotelContactDetail && HotelContactDetail?.length > 0 && (
                  <>
                    <KendoGrid
                      style={{ marginTop: 14 }}
                      data={
                        HotelContactDetail
                          ? HotelContactDetail?.slice(
                              hotelPage.skip,
                              hotelPage.take + hotelPage.skip,
                            )
                          : []
                      }
                      skip={hotelPage.skip}
                      take={hotelPage.take}
                      total={HotelContactDetail?.length}
                      pageable={{
                        buttonCount: 5,
                        pageSizes: [10, 25, 50, "All"],
                        pageSizeValue: hotelPageSizeValue,
                        type: "input",
                      }}
                      onPageChange={pageChangeForHotel}
                      cells={{
                        headerCell: HeaderCustomCell,
                        data: MyDataCustomCell,
                      }}
                    >
                      <Column field="ContactPersonName" title="Name" />
                      <Column
                        field="ContactPersonMobileNo"
                        title="Mobile No."
                      />
                      <Column field="ContactPersonEmailID" title="Email ID" />
                      <Column
                        field="ContactPersonDesignation"
                        title="Designation"
                      />
                      <Column
                        field="ID"
                        title="Status"
                        cell={MyActiveInActtiveCommandCell}
                        width={"90px"}
                        filterable={false}
                        locked={true}
                      />
                      <Column
                        field="ID"
                        title="Actions"
                        cell={(props: any) =>
                          MyEditHotelCommandCell(props, formRenderProps)
                        }
                        width={"110px"}
                        filterable={false}
                        locked={true}
                      />
                    </KendoGrid>
                  </>
                )}
              </ShadowCard>
            </FormElement>
          );
        }}
      />
    </>
  );
};

const DeleteHotelDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const location = useLocation();
  const HotelID = location.state?.HotelID;

  const HotelContactID = useAppSelector((state) => state.hotel.HotelContactID);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteHotelContact(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getAllHotelContacts({ HotelID: HotelID }));
        dispatch(closeDialog());
        dispatch(clearHotelContactID());
      } else {
        dispatch(getAllHotelContacts({ HotelID: HotelID }));
        dispatch(closeDialog());
        dispatch(clearHotelContactID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteHotelContact" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Contact?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Contact?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(HotelContactID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default CreateHotelContact;
